// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__Z1R5k","notes":"Notes_notes__1_Ya5"};